import PropTypes from 'prop-types';
import React from 'react';

import InfoButton from '../../../components/InfoButton';
import { POWER6_KEYS } from '../../../utils/constants';

import styles from '../search.scss';

const HighSchoolHeaderColumns = props => {
    const { filterType, highSchools, isPowerUser, isRostersRolloutEnabled } = props;
    const power6SortKey = isRostersRolloutEnabled ? POWER6_KEYS.ACTIVE_ROSTER : POWER6_KEYS.SCHOOL;

    let sortValue = '';
    if (highSchools.sort && highSchools.sort.field) {
        sortValue = `${highSchools.sort.field}_${highSchools.sort.asc ? 'asc' : 'desc'}`;
    }
    const sortOptions = [
        { value: 'name_asc', label: 'Name: A to Z' },
        { value: 'name_desc', label: 'Name: Z to A' },
        { value: `${power6SortKey}_asc`, label: 'P6: Low to high' },
        { value: `${power6SortKey}_desc`, label: 'P6: High to low' },
    ];

    const sort = (val) => {
        const sortBy = val.split('_');
        props.sortResults('highSchools', sortBy[0], sortBy[1]);
    };

    function sortDefaultDesc(type, field) {
        if (highSchools.sort.field !== field || (highSchools.sort.field === field && highSchools.sort.asc === false)) {
            props.sortResults(type, field, 'asc');
        } else {
            props.sortResults(type, field, 'desc');
        }
    }

    return (
        highSchools.total > 0
            ? (
                <div>
                    <div className={`${styles.searchHeaders} d-none d-md-flex`} data-testid="search.high-schools.column-headers">
                        <div className="flex-grow">
                            <div className="row">
                                <div
                                    className={`col-md-5 ${styles.searchHeaderColumn} ${filterType && styles.clickable} ${filterType && highSchools.sort.field === 'name' ? 'active' : ''}`}
                                    onClick={() => { return filterType ? props.sortResults('highSchools', 'name') : null; }}
                                    data-testid="search.high-schools.column-header.name"
                                >
                                    {(filterType ? <span data-testid="search.high-schools.column-header.name-label">Name <i className={`uts ${highSchools.sort.field === 'name' && !highSchools.sort.asc ? 'uts-expand' : 'uts-collapse'}`} /></span> : <span data-testid="search.high-schools.column-header.name-label">High Schools</span>)}
                                </div>
                                <div className={`col-md-3 ${styles.searchHeaderColumn}`} data-testid="search.high-schools.column-header.location">Location</div>
                                <div className={'col-md-4'}>
                                    <div className="row w-100">
                                        {isPowerUser && (
                                            <div
                                                className={`col-md-4 offset-md-8 ${styles.searchHeaderColumn} ${filterType && styles.clickable} ${filterType && highSchools.sort.field === power6SortKey ? 'active' : ''}`}
                                                onClick={() => { return filterType ? sortDefaultDesc('highSchools', power6SortKey) : null; }}
                                                data-testid="search.high-schools.column-header.p6"
                                            >
                                                P6 {(filterType && <i className={`uts ${highSchools.sort.field === power6SortKey && !highSchools.sort.asc ? 'uts-expand' : 'uts-collapse'}`} />)}
                                                <InfoButton
                                                    hoverText={(
                                                        <div>
                                                            Sum of top 6 players on the current team roster. If the team is mixed, there is a Power 6 rating for both boys and girls
                                                        </div>
                                                    )}
                                                    data-testid="search.high-schools.column-header.p6.info-btn"
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.searchHeaders} d-block d-md-none`} data-testid="search.high-schools.column-headers-mobile">
                        {filterType ? (
                            <div className={``} data-testid="search.high-schools.sort-by-wrapper">
                                Sort by
                                <select
                                    className="inline-input"
                                    value={sortValue}
                                    onChange={(e) => sort(e.target.value)}
                                    data-testid="search.high-schools.sort-select"
                                >
                                    <option value="">Relevance</option>
                                    {sortOptions.map((option, i) => <option value={option.value} key={`hsSort${i}`}>{option.label}</option>)}
                                </select>
                            </div>
                        ) : 'High Schools'}
                    </div>
                </div>
            ) : <div />
    );
};

HighSchoolHeaderColumns.propTypes = {
    highSchools: PropTypes.objectOf(PropTypes.any).isRequired,
    filterType: PropTypes.string,
    isPowerUser: PropTypes.bool,
    isRostersRolloutEnabled: PropTypes.bool,
    sortResults: PropTypes.func,
};

HighSchoolHeaderColumns.defaultProps = {
    filterType: '',
    isPowerUser: false,
    isRostersRolloutEnabled: false,
    sortResults: () => {},
};

export default HighSchoolHeaderColumns;
